/* eslint-disable arrow-body-style */
import React from 'react';

function WelcomeLoading() {
  return (
    <div className="text-center w-full text-gray-500 font-normal text-xl mt-16">
      Loading... 🙃
    </div>
  );
}

export default WelcomeLoading;
